import React from 'react';

import { Logo } from '@/shared/components/ui/logo/logo';
import { useAppTheme } from '@/shared/features/theme-switcher/context/theme-context';
import { LogoVariantEnum, ThemeEnum } from '@/shared/types/common.types';
import { getReseller } from '@/shared/utils/reseller/reseller';
import { getResellerLogo } from '@/shared/utils/reseller-logo/reseller-logo';

export const ConditionalLogo: React.FC = () => {
  const { selectedTheme } = useAppTheme();
  const reseller = getReseller();

  if (reseller !== 'sda') {
    const ResellerLogo = getResellerLogo(reseller);

    if (!ResellerLogo) {
      console.error(`Reseller logo not found for: ${reseller}`);
      return null;
    }

    return <ResellerLogo />;
  }

  return (
    <>
      <Logo
        variant={LogoVariantEnum.ICON}
        isDarkMode={selectedTheme !== ThemeEnum.LIGHT}
      />
      <Logo
        variant={LogoVariantEnum.TEXT}
        isDarkMode={selectedTheme !== ThemeEnum.LIGHT}
      />
    </>
  );
};
